import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Drawer } from 'ui-components/components/drawer/drawer';
import { DrawerHeader } from 'ui-components/components/drawer/drawer-header';
import { FlexRow } from 'ui-components/components/flex';

import messages from '../messages';
import style from './style.module.less';
import { useModal } from '../../../../hooks/use-modal';
import { GenerateTotesDrawer } from '../modals/generate-totes-drawer';
import { WarehouseDrawerContent } from '../warehouse-drawer-content';

/**
 * @param {object} props
 * @param {string} props.inventoryWarehouseId
 * @param {() => void} props.onClose
 * @param {string} props.warehouseName
 * @param {(newName: string) => void} props.onWarehouseNameUpdate
 * @param {(id: string, name: string) => void} props.changeWarehouse
 * @returns {JSX.Element}
 */

export const ConfigureWarehouseDrawer = ({ inventoryWarehouseId, onClose, warehouseName, onWarehouseNameUpdate, changeWarehouse }) => {
  const { isOpen, close, open } = useModal();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const handleOpenCreateTotes = useCallback(() => {
    open();
  }, [open]);

  return (
    <>
      <Drawer canvasClassName={style['configure-warehouse-canvas']} onCancel={onClose} onClose={onClose}>
        <DrawerHeader
          className={style['drawer-header']}
          closeButtonAriaLabel={messages.closeConfigureWarehouseButtonAriaLabel}
          title={<FormattedMessage {...messages.configureWarehouseDrawerHeaderText} />}
          titleClassName={style['drawer-header-title']}
        />
        <FlexRow className={style['scrollable-container']}>
          <WarehouseDrawerContent
            changeWarehouse={changeWarehouse}
            inventoryWarehouseId={inventoryWarehouseId}
            onCreateTotes={handleOpenCreateTotes}
            onWarehouseNameUpdate={onWarehouseNameUpdate}
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={setSelectedTabIndex}
            warehouseName={warehouseName}
          />
        </FlexRow>
      </Drawer>
      {isOpen ? <GenerateTotesDrawer inventoryWarehouseId={inventoryWarehouseId} onClose={close} warehouseName={warehouseName} /> : null}
    </>
  );
};
